// JavaScript source code
'use strict'


window.addEventListener("load", function () {

    //プラグインを定義
    //   gsap.registerPlugin(ScrollTrigger);

    const area = document.querySelector(".js-area");
    const wrap = document.querySelector(".js-wrap");
    const items = document.querySelectorAll(".js-item");
    const num = items.length;

    //横幅を指定
    gsap.set(wrap, { width: num * 100 + "%" });
    gsap.set(items, { width: 100 / num + "%" });

});

$(function () {
    $("#start").click(function () {
        next();
        // $("#next").removeClass("display_none");
        $(this).addClass("display_none");
    });

    // 次ページ
    $("#next").click(function () {
        if (active_check()) {
            next();
        }
    });

    // 前ページ
    $("#back").click(function () {
        $("#next").addClass("display_none");
        back();
    });
});

//選択ボタンの処理
// Q1
$(function () {
    $(".Q1").on("click", function () { // tabをクリックしたらイベント発火
        $(".Q1").removeClass("active"); // activeクラスを消す
        $(this).addClass("active"); // クリックした箇所にactiveクラスを追加
        next();
    })
})

// Q2
$(function () {
    $(".Q2").on("click", function () { // tabをクリックしたらイベント発火
        $(".Q2").removeClass("active"); // activeクラスを消す
        $(this).addClass("active"); // クリックした箇所にactiveクラスを追加
        next();
    })
})

// Q3
$(function () {
    $(".Q3").on("click", function () { // tabをクリックしたらイベント発火
        $(".Q3").removeClass("active"); // activeクラスを消す
        $(this).addClass("active"); // クリックした箇所にactiveクラスを追加
        next();
    })
})

// Q4
$(function () {
    $(".Q4").on("click", function () { // tabをクリックしたらイベント発火
        $(".Q4").removeClass("active"); // activeクラスを消す
        $(this).addClass("active"); // クリックした箇所にactiveクラスを追加
        next();
    })
})


// Q5
$(function () {
    $(".Q5").on("click", function () { // tabをクリックしたらイベント発火
        $(".Q5").removeClass("active"); // activeクラスを消す
        $(this).addClass("active"); // クリックした箇所にactiveクラスを追加
        next();
        $("#next").removeClass("display_none");
    })
})


// Q6　複数選択
$(function () {
    $(".Q6").on("click", function () { // tabをクリックしたらイベント発火
        if ($(this).hasClass('active')) {
            $(this).removeClass("active"); // クリックした箇所のactiveクラスを消す
        } else {
            $(".Q6A0").removeClass("active"); // activeクラスを消す
            $(this).addClass("active"); // クリックした箇所にactiveクラスを追加
        }
    })
})

// Q6　悩みなし
$(function () {
    $(".Q6A0").on("click", function () { // tabをクリックしたらイベント発火
        $(".Q6").removeClass("active"); // activeクラスを消す
        $(this).addClass("active"); // クリックした箇所にactiveクラスを追加
        callback();
    })
})


function next() {
    var myclass = document.getElementById("button_frame").className;
    var num = +myclass + 1
    if (num > 7) {
        callback();
        return;
    }
    const items = document.querySelectorAll(".js-item");
    gsap.to(items, {
        xPercent: -100 * (num - 1), //x方向に移動させる
        ease: "none",
        onComplete: () => adjustHeight(num)
    });
    $("#button_frame").removeClass(myclass);
    $("#button_frame").addClass(`${num + ""}`);
    // $("#next").addClass("onclic", 15, validate);
    if (num > 2) {
        $("#back").removeClass("display_none");
    }
    if (num > 6) {
        $("#next").addClass("finish");
        document.getElementById("next").innerText = ``;
    }
    if (num > 7) {
        $("#back").addClass("display_none");
        $("#next").addClass("display_none", 150, callback);
    }
    return false;   // この行追加
};

function back() {
    var myclass = document.getElementById("button_frame").className;
    var num = +myclass - 1
    const items = document.querySelectorAll(".js-item");
    gsap.to(items, {
        xPercent: -100 * (num - 1), //x方向に移動させる
        ease: "none",
        onComplete: () => adjustHeight(num)
    });
    $("#button_frame").removeClass(myclass);
    $("#button_frame").addClass(`${num + ""}`);
    if (num <= 2) {
        $("#back").addClass("display_none");
    }

    if (num < 7) {
        $("#next").removeClass("finish");
        document.getElementById("next").innerText = `NEXT`;
    }
}

function adjustHeight(num){
  const items = document.querySelectorAll(".js-item");
  const current = items[num - 1];
  if(!current) return;

  // 表示中スライドの高さに合わせる（下ボタン分を足す）
//   const h = current.scrollHeight;
//   document.querySelector(".area.js-area").style.minHeight = h + "px";
}

function callback() {
    /// 要素を取得
    const items = document.querySelectorAll(".active");
    let base_Yellow = 0;
    let base_blue = 0;
    let brightness_high = 0;
    let brightness_low = 0;
    let saturation_high = 0;
    let saturation_low = 0;
    let color_pure = 0;
    let color_muddy = 0;

    // 選択状態の値を取得
    for (var i = 0; i < items.length; i++) {
        let ans_values = items[i].getAttribute('value').split(",");
        base_Yellow = base_Yellow + Number(ans_values[0]);
        base_blue = base_blue + Number(ans_values[1]);
        brightness_high = brightness_high + Number(ans_values[2]);
        brightness_low = brightness_low + Number(ans_values[3]);
        saturation_high = saturation_high + Number(ans_values[4]);
        saturation_low = saturation_low + Number(ans_values[5]);
        color_pure = color_pure + Number(ans_values[6]);
        color_muddy = color_muddy + Number(ans_values[7]);
    }

    let spring = base_Yellow + brightness_high + saturation_high + color_pure;
    let summer = base_blue + brightness_low + saturation_high + color_muddy;
    let autumn = base_blue + brightness_low + saturation_low + color_pure;
    let winter = base_Yellow + brightness_high + saturation_low + color_muddy;
    if (Math.max(spring, summer, autumn, winter) == spring) {
        console.log(`spring`)
    } else if (Math.max(spring, summer, autumn, winter) == summer) {
        console.log(`summer`)
    } else if (Math.max(spring, summer, autumn, winter) == autumn) {
        console.log(`autumn`)
    } else {
        console.log(`winter`)
    }

    // ロジック２
    let container_1 = 0;
    let container_2 = 0;
    let container_3 = 0;
    if ($(Q6A1).hasClass('active')) {
        if ($(Q6A2).hasClass('active')) {
            container_1 = 0; //イエベ　+　ブルベ
        } else {
            container_1 = 1; //イエベ
        }
    } else if ($(Q6A2).hasClass('active')) {
        container_1 = 2; //ブルベ
    } else {
        container_1 = 0; //none
    }

    if ($(Q6A3).hasClass('active')) {
        if ($(Q6A4).hasClass('active')) {
            container_2 = 2; //むくみ＋シミ・シワ
        } else {
            container_2 = 3; //むくみ
        }
    } else {
        if ($(Q6A4).hasClass('active')) {
            container_2 = 4; //シミ・シワ
        } else {
            container_2 = 0; //none
        }
    } 

//    if ($(Q6A5).hasClass('active')) {
//         if ($(Q6A3).hasClass('active')) {
//             container_2 = 0; //手瘦せ＋むくみ
//         } else if ($(Q6A4).hasClass('active')) {
//             container_2 = 1; //手瘦せ＋シミ・シワ
//         } else {
//             container_2 = 5; //手瘦せ
//         }
//     } else if ($(Q6A3).hasClass('active')) {
//         if ($(Q6A4).hasClass('active')) {
//             container_2 = 2; //むくみ＋シミ・シワ
//         } else {
//             container_2 = 3; //むくみ
//         }
//     } else {
//         if ($(Q6A4).hasClass('active')) {
//             container_2 = 4; //シミ・シワ
//         } else {
//             container_2 = 0; //none
//         }
//     }

    if ($(Q6A9).hasClass('active')) {
        container_3 = 7; //乾燥
    } else {
        container_3 = 0; //none
    }

    // if ($(Q6A9).hasClass('active')) {
    //     if ($(Q6A7).hasClass('active')) {
    //         container_3 = 0; //乾燥＋テカリ
    //     } else if ($(Q6A6).hasClass('active')) {
    //         if ($(Q6A8).hasClass('active')) {
    //             container_3 = 2; //乾燥＋色ムラ＋たるみ
    //         } else {
    //             container_3 = 0; //乾燥＋色ムラ
    //         }
    //     } else if ($(Q6A8).hasClass('active')) {
    //         container_3 = 4; //乾燥＋たるみ
    //     } else {
    //         container_3 = 7; //乾燥
    //     }
    // } else if ($(Q6A7).hasClass('active')) {
    //     if ($(Q6A6).hasClass('active')) {
    //         if ($(Q6A8).hasClass('active')) {
    //             container_3 = 1; //テカリ＋色ムラ＋たるみ
    //         } else {
    //             container_3 = 3; //テカリ＋色ムラ
    //         }
    //     } else {
    //         if ($(Q6A8).hasClass('active')) {
    //             container_3 = 0; //テカリ＋たるみ
    //         } else {
    //             container_3 = 6; //テカリ
    //         }
    //     }
    // } else if ($(Q6A6).hasClass('active')) {
    //     if ($(Q6A8).hasClass('active')) {
    //         container_3 = 0; //色ムラ＋たるみ
    //     } else {
    //         container_3 = 5; //色ムラ
    //     }
    // } else if ($(Q6A8).hasClass('active')) {
    //     container_3 = 8; //たるみ
    // } else {
    //     container_3 = 0; //none
    // }    

    // ブラシ対応
    let container_4 = 0;

    // if ($(Q7A2).hasClass('active')) {
    //     container_4 = 1; //ブラシM
    // } else {
    //     container_4 = 0; //ブラシS
    // }

    setTimeout(function () {
        window.location.href = `https://shiki-personal-color.myshopify.com/pages/6questions_result?result=${base_Yellow},${base_blue},${brightness_high},${brightness_low},${saturation_high},${saturation_low},${color_pure},${color_muddy},${container_1},${container_2},${container_3},${container_4},`;
        // window.location.href = `Shiki-WP_ResultPage.html?result=${base_Yellow},${base_blue},${brightness_high},${brightness_low},${saturation_high},${saturation_low},${color_pure},${color_muddy},${container_1},${container_2},${container_3},${container_4},`;
        // window.location.href = `https://shikipersonalcolor.jp/wp-content/result/Shiki-WP_ResultPage.html?result=${base_Yellow},${base_blue},${brightness_high},${brightness_low},${saturation_high},${saturation_low},${color_pure},${color_muddy},${container_1},${container_2},${container_3},${container_4},`;
        console.log(`${base_Yellow},${base_blue},${brightness_high},${brightness_low},${saturation_high},${saturation_low},${color_pure},${color_muddy}`);
    }, 1);
}

function active_check() {
    var myclass = document.getElementById("button_frame").className;
    var num = +myclass - 1
    // switch (num) {
    return document.querySelector(`a[class="Q${num} active"]`) != null
    // }
}


window.onload = function () {
    //ここでローディング画像を表示していたDIVを非表示にする
    // document.getElementById('load').style.display = 'none';
    
    //ここで本体を表示にさせる
    // document.getElementById('wrapper').style.display = 'block';	

    // 実行したい処理
    document.querySelector("div[class='area js-area']").style.visibility = "visible"
}

